import axiosInstance from '../../axios-config';

const getExternalSystemsApi = '/api/patients/{0}/externalSystems';

export const getExternalSystems = (patientId) =>
  axiosInstance.get(getExternalSystemsApi.replace('{0}', patientId));
